import { Pipe, PipeTransform } from '@angular/core';
import { RequestLineModel } from '../models/request-line.model';

@Pipe({
  name: 'totalAmount'
})
export class TotalAmountPipe implements PipeTransform {

  transform(lines: RequestLineModel[]): number {

    let result = 0;

    lines.forEach(line => {
      result += line.amount;
    });

    return result;
  }

}
